(function(){

  'use strict';

  angular.module('clientDashboardApp.admin.adminPageInfo',[]).provider('adminPageInfo',function(){

    var pageInfo = {};
    var previousPageInfo = {
      type: null,
      mode: null
    }

    return {
      setIfFirstTimeAppLoad: function(info){
        if(!previousPageInfo.type){
          this.setCurrentPageInfo(info);
        }
        return info;
      },
      setCurrentPageInfo: function (info) {
        this.setPreviousPageInfo(pageInfo);
        pageInfo = info;
      },
      getCurrentPageInfo: function () {
        return pageInfo;
      },
      setPreviousPageInfo: function (info){
        previousPageInfo = info;
      },
      getPreviousPageInfo: function () {
        return previousPageInfo;
      },
      pageModeChange : function () {
        if(previousPageInfo && pageInfo){
          return previousPageInfo.mode !== pageInfo.mode;
        }
        else{
          return true;
        }
      },
      pageTypeChange : function () {
        if(previousPageInfo && pageInfo){
          return previousPageInfo.type !== pageInfo.type;
        }
        else {
          return true;
        }
      },
      $get : function(){
        return this;
      }
    }

  })

})();
